import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, Optional, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TaxReturnService } from '../../../../../swaggerServices/api/api';
import { ITaxReturn } from '../../../../app/tax-returns/tax-return/model/i-tax-return';
import { ConfigStateService } from '../../../../app/config/config-state.service';
import { cloneDeep } from "lodash-es";
import { Tenant } from '../../../types/tenant.enum';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TenantConfigService } from '../../../services/tenant-config.service';
@Component({
    selector: 'revise-confirmation',
    templateUrl: './revise-confirmation.component.html',
    styleUrls: ['./revise-confirmation.component.scss'],
    standalone: false
})
export class ReviseConfirmationComponent implements OnInit, OnDestroy {
  taxReturn: ITaxReturn;
  @Output() closed = new EventEmitter();
  @Output() completed = new EventEmitter();
  comfirmationModelType: 'UNLOCK_APS' | 'REVISION_COUNT' | 'CONFIRMATION';
  selectedSource: string;
  revisionCount: number;
  subscriptions: Subscription[] = [];
  uiConfig: TenantConfigService;
  taxReturnAlias: string;
  private unsubscribe: Subject<void> = new Subject();
  private dialogData: { taxReturn: ITaxReturn } = inject(MAT_DIALOG_DATA);

  constructor(
    private taxReturnService: TaxReturnService,
    private configState: ConfigStateService,
    @Optional() private dialogRef?: MatDialogRef<ReviseConfirmationComponent>
  ) {
    this.taxReturn = this.dialogData.taxReturn;
  }

  ngOnInit() {
    if (this.configState.featureFlags.amendmentRevisionCount) {
      this.comfirmationModelType = 'REVISION_COUNT';
      this.revisionCount = cloneDeep(this.taxReturn.revisionCount + 1);
    } else if (this.configState.tenant === Tenant.ESS) {
      this.comfirmationModelType = 'CONFIRMATION';
      this.revisionCount = cloneDeep(this.taxReturn.revisionCount + 1);
    } else {
      this.comfirmationModelType = 'UNLOCK_APS';
    }
    this.subscriptions.push(
      this.configState.loadConfig().subscribe(configState => {
        this.uiConfig = new TenantConfigService(configState);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias
      })
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.subscriptions.forEach(s => s.unsubscribe());

  }

  confirmRevise() {
    if (this.configState.tenant === Tenant.ESS) {
      return this.taxReturnService.waitingForPrep(this.taxReturn.id)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(() => {
          this.completed.emit();
        });
    } else {
      return this.taxReturnService.updateTaxReturnReviseAfterRejection(this.taxReturn.id, { revisionCount: this.revisionCount },)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(() => {
          this.completed.emit();
        });
    }

  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.closed.emit();
  }
}
